import styled, { css } from 'styled-components';

import { TextButton as TextButtonComponent } from '@xingternal/button';
import { scale150, spaceM, spaceXL } from '@xingternal/tokens';

export const Container = styled.section`
  display: flex;
  margin-top: ${spaceXL};
`;

export const FiltersRow = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  flex-wrap: wrap;

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    css`
      overflow: hidden;
      height: calc(${scale150} + ${spaceM}); /* filter button height + margin */
    `}
`;

export const TextButton = styled(TextButtonComponent)`
  flex-shrink: 0;
  margin-top: ${spaceM};
  margin-left: auto;
`;
